import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import TextField from '@mui/material/TextField'
import MenuItem from '@mui/material/MenuItem'

const languages = [
    { code: 'en', label: 'English' },
    { code: 'tr', label: 'Türkçe' },
    { code: 'es', label: 'Español' },
    { code: 'zh', label: '简体中文' },
    { code: 'de', label: 'Deutsch' },
    { code: 'ja', label: '日本語' },
    { code: 'pt', label: 'Português' },
]

interface LanguageSwitcherProps {
    value?: string
    onChange?: (lang: string) => void
    disabled?: boolean
}

const LanguageSwitcher = ({
    value,
    onChange,
    disabled,
}: LanguageSwitcherProps): ReactElement => {
    const { t } = useTranslation()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const lang = event.target.value
        onChange?.(lang)
    }

    return (
        <TextField
            select
            id="language-select"
            label={t('language')}
            value={value}
            onChange={handleChange}
            variant="outlined"
            fullWidth
            disabled={disabled}
        >
            {languages.map((lang) => (
                <MenuItem
                    key={lang.code}
                    id={`language-select-${lang.code}`}
                    value={lang.code}
                >
                    {lang.label}
                </MenuItem>
            ))}
        </TextField>
    )
}

export default LanguageSwitcher
